import { StringKey } from './string-key.enum';

export const sarMessages: Record<StringKey, string> = {
  // FAQsSection
  [StringKey.FAQ_LABEL]: 'تعرف اكثر على منصة معازيب',
  [StringKey.FREQUENTLY_ASKED_QUESTIONS]: 'الأسئلة الشائعة',
  [StringKey.FAQS_SUBTITLE]: 'إجابات مختصرة على الأسئلة الشائعة لإبقائك على اطلاع.',
  [StringKey.FAQ_1_TITLE]: 'ما هو نظام معازيب؟',
  [StringKey.FAQ_1_DESC]:
    'معازيب هو نظام تقني سعودي متخصص في إدارة الفعاليات، ويُعد الأول من نوعه في تقديم حلول تقنية متكاملة لقطاع إدارة وتنظيم الفعاليات. تم تطوير النظام لتلبية احتياجات منظم الفعالية بشكل شامل وسلس، من خلال ربطه بجميع أصحاب المصلحة مثل الموردين، الرعاة، المتحدثين، العارضين، والحضور، عبر أدوات ذكية مبنية على خبرات ميدانية في تشغيل وإدارة الفعاليات. يوفر معازيب بيئة رقمية موحدة تسهّل عمليات التخطيط والتشغيل والتواصل والتسويق، مما يساهم في تنفيذ فعاليات احترافية بكفاءة وانسيابية عالية.',
  [StringKey.FAQ_2_TITLE]: 'هل معازيب مجاني للاستخدام؟',
  [StringKey.FAQ_2_DESC]:
    'التسجيل في نظام معازيب متاح مجانًا لجميع المستخدمين، باستثناء منظمي الفعاليات الذين يمكنهم الاشتراك في باقات مدفوعة مصممة بما يتناسب مع حجم الفعالية واحتياجاتهم التشغيلية. أما الرعاة، المتحدثون، الموردون، والعارضون، فيمكنهم استخدام النظام دون أي رسوم، مع تطبيق نسبة رمزية فقط عند الاستفادة من الفرص والمشاريع المتاحة داخل النظام.',
  [StringKey.FAQ_3_TITLE]: 'كيف يمكنني إنشاء فعالية عبر نظام معازيب؟',
  [StringKey.FAQ_3_DESC]:
    'تم تصميم نظام معازيب ليخدم جميع الأطراف المعنية بالفعالية، من منظمين ورعاة ومتحدثين وموردين وعارضين إلى الحضور، حيث يحصل كل طرف على أدوات مخصصة لدوره. ما عليك سوى اختيار دورك عند التسجيل، وستتمكن من إدارة الفعاليات أو الانضمام إليها بكل سهولة من خلال لوحة تحكم موحّدة وشاملة.',
  [StringKey.FAQ_4_TITLE]: 'هل يمكنني الانضمام إلى فعالية بصفتي راعيًا أو متحدثًا أو موردًا؟',
  [StringKey.FAQ_4_DESC]:
    'نعم، بعد إتمام التسجيل المجاني في نظام معازيب، يمكنك تصفّح الفعاليات المتاحة والتقدّم للانضمام إليها حسب الدور المناسب لك، سواء كراعي، متحدث، أو مورد، وفقًا لنطاق العمل المطلوب. كما يمكنك التواصل المباشر مع المنظمين للاطلاع على التفاصيل واتخاذ القرار المناسب.',
  [StringKey.FAQ_5_TITLE]: 'ما أنواع الفعاليات التي يدعمها نظام معازيب؟',
  [StringKey.FAQ_5_DESC]:
    'يدعم معازيب مجموعة متنوعة من الفعاليات تشمل الحفلات والأنشطة الترفيهية، المؤتمرات والمعارض، الفعاليات الثقافية والتعليمية، بالإضافة إلى الفعاليات الحكومية والخاصة. مما يجعله نظامًا مرنًا وشاملًا يُلبّي احتياجات مختلف قطاعات الفعاليات.',
  [StringKey.FAQ_6_TITLE]: 'ما هي قنوات الوصول إلى نظام معازيب؟',
  [StringKey.FAQ_6_DESC]:
    'يتيح معازيب الوصول إليه عبر تطبيق مخصص للهواتف الذكية ونظام إلكتروني على الويب، ويوفّر بيئة تواصل مباشرة بين جميع الأطراف المعنية، مدعومة بإشعارات وتنبيهات فورية تضمن تجربة متكاملة وسلسة من التخطيط وحتى التقييم.',

  // FeaturesExtraSection
  [StringKey.ORGANIZER]: 'منظم',
  [StringKey.ORGANIZER_DESC]: `أنت المعزب، يمنحك معازيب تحكمًا كاملاً من خلال مجموعة متكاملة من الميزات التي تغطي كل مراحل الفعالية. كل ذلك عبر نظام ذكي واحد، لتتمكن من التركيز على تقديم تجربة استثنائية. ركز على النجاح، واترك التفاصيل علينا!`,
  [StringKey.BOOK_A_DEMO]: 'احجز عرض تجريبي',
  [StringKey.JOIN_WAITLIST]: 'انضم إلى قائمة الانتظار!',
  [StringKey.VENDOR_SPONSOR_EXHIBITOR_SPEAKER]: 'المورد، الراعي، المتحدث، والعارض',
  [StringKey.VENDOR_SPONSOR_DESC]:
    'سجّل مجانًا في معازيب وكن جزءًا من شبكة فعاليات متكاملة. من خلال معازيب، يمكنك عرض خدماتك والمشاركة في الفعاليات التي تُنظَّم عبر النظام مع إمكانية التواصل المباشر مع المنظمين، وفهم نطاق العمل قبل بدء أي التزام. كل دور له أدواته، وكل فرصة تبدأ من هنا.',
  [StringKey.ATTENDEE]: 'الحضور',
  [StringKey.ATTENDEE_DESC]:
    'استكشف عالم الفعاليات بين يديك.حمّل تطبيق معازيب واختر الفعاليات التي تناسب ذوقك واهتماماتك من حفلات ومؤتمرات إلى معارض وتجارب ثقافية. كل ما تحتاجه... في مكان واحد.',
  [StringKey.ATTENDEE_DESC_2]: 'كل ما تحتاجه... في مكان واحد',
  [StringKey.FEATURES_SECTION_EXTRA_LABEL_1]: 'ميزات مدمجة ومصممة لتحقيق تأثير فعّال',
  [StringKey.FEATURES_SECTION_EXTRA_TITLE_1]: 'تعرّف على ما يقدمه معازيب',
  [StringKey.FEATURES_SECTION_EXTRA_DESC_1]:
    'معازيب يوفّر للمنظمين والمورّدين والرعاة والمتحدثين والحضور أدوات ذكية تمكّنهم من التخطيط المتقن والتواصل السريع وصناعة تجربة فعالية استثنائية.',
  [StringKey.ORGANIZE_WITH_CONFIDENCE]: 'نظم بثقة.',
  [StringKey.WIN_MORE_TENDERS]: 'اربح المزيد من المناقصات. اعمل بذكاء.',
  [StringKey.BRANDED_TICKETS]: 'دعواتك وتذاكرك بهويتك، تصل بسهولة.',
  [StringKey.SPONSORS_IMPACT]: 'ابرز علامتك التجارية في اكبر الفعاليات بأثر ملموس.',
  [StringKey.FEATURES_SECTION_EXTRA_LABEL_2]: 'معازيب صنع بخبرات سعودية في مجال إدارة الفعاليات',
  [StringKey.FEATURES_SECTION_EXTRA_TITLE_2]: 'منظومة متكاملة تخدم جميع الأدوار',
  [StringKey.FEATURES_SECTION_EXTRA_DESC_2]:
    'معازيب يجمع جميع الأطراف المعنية في مكان واحد ويزوّد كل طرف بالأدوات التي يحتاجها للنجاح قبل الفعالية وأثناءها وبعدها.',

  // FeaturesSection
  [StringKey.EVENTS]: 'الفعاليات',
  [StringKey.BUDGET]: 'الميزانية',
  [StringKey.SOCIAL]: 'اجتماعي',
  [StringKey.TENDERS]: 'المناقصات',
  [StringKey.INVITATIONS]: 'دعوات',
  [StringKey.TICKETS]: 'تذاكر',
  [StringKey.TEAMS]: 'الفرق',
  [StringKey.CALENDAR]: 'التقويم',
  [StringKey.FEATURES_SECTION_LABEL_1]: 'إدارة الفعاليات بقدرات تقنية متقدمة في مكان واحد',
  [StringKey.FEATURES_SECTION_TITLE_1]: 'معازيب يسهّل ادارة فعاليتك',
  [StringKey.FEATURES_SECTION_DESC_1]:
    'من التخطيط والتنفيذ، إلى المناقصات والعقود الإلكترونية، والتنسيق مع أصحاب المصلحة، مرورًا بالتذاكر والدعوات. معازيب يجمع كل عناصر الحدث في منصة واحدة مصممة خصيصًا لتلبية احتياجات معزب الفعالية. ودّع الأدوات المبعثرة، وابدأ تجربة متكاملة بتدفق ذكي واستخدام موحد.',
  [StringKey.LARGE_CARD_TEXT_1]: 'كل أعضاء فريقك في نفس الصفحة نظّم، تابع، ونفّذ من مكان واحد.',
  [StringKey.LARGE_CARD_TEXT_2]:
    'بسّط إدارة المحتوى، أنشئ، وجدول، وانشر حملتك التسويقية على جميع المنصات بضغطة زر من مكان واحد.',
  [StringKey.LARGE_CARD_TEXT_3]:
    'خطط ميزانيتك، وتتبع نفقاتك، وتحكم بتكاليف الفعالية لحظة بلحظة كل شيء واضح وتحت سيطرتك، وفّر الوقت وتجنّب المفاجآت.',
  [StringKey.LARGE_CARD_TEXT_4]:
    'كل ما تحتاجه في مكان واحد موردون، رعاة، متحدثون، وعارضون مختارون بعناية لإنجاح فعاليتك.',
  [StringKey.LARGE_CARD_TEXT_5]:
    'أمّن جميع الأطراف عبر نظام عقود رقمي موثوق يحفظ الاتفاقيات وينظّمها في منصة واحدة.',
  [StringKey.LARGE_CARD_TEXT_6]:
    'اسأل وتواصل وتعرّف على نطاق العمل، فكل مشروع له مركز معرفة متكامل.',
  [StringKey.FEATURES_SECTION_LABEL_2]: 'معازيب ينهي عناء تنسيق أصحاب المصلحة',
  [StringKey.FEATURES_SECTION_TITLE_2]: 'معازيب… حيث يلتقي الجميع تحت سقف واحد',
  [StringKey.FEATURES_SECTION_DESC_2]:
    'من المنظمين إلى الحضور، مرورًا بالمورّدين والرعاة والعارضين والمتحدثين. معازيب يجمع كل الأطراف في منصة ذكية ومتصلة. خطط وتواصل وتعاون بسهولة، لأن نجاح أي فعالية يبدأ بفريق متناسق.',

  // ProductSection
  [StringKey.THE_PLACE_IS_YOURS]: 'المكان مكانك',
  [StringKey.ALL_IN_ONE_HUB]: 'الحل الشامل لإدارة الفعاليات',
  [StringKey.MAAZEEB_PLATFORM_DESC]:
    'معازيب هو نظام سعودي يجمع جميع أصحاب المصلحة في الفعالية تحت مظلة رقمية واحدة. يدعم المنظمين قبل الفعالية في التخطيط والإعداد، وأثناء الفعالية في التنسيق، والتشغيل، والتسويق، وبعد الفعالية في التحليل وإصدار التقارير. وكل ذلك من خلال أدوات ذكية ومتكاملة ضمن نظام موحد.',
  [StringKey.LEARN_MORE]: 'اعرف المزيد',
  [StringKey.REGISTER_NOW]: 'سجل الآن',

  // PricingSection
  [StringKey.PRICING_SECTION]: 'قسم التسعير',

  // Footer
  [StringKey.FOOTER_COPYRIGHT]: '© {year} معازيب. جميع الحقوق محفوظة.',

  // Header/Nav
  [StringKey.NAV_PRODUCT]: 'المنتج',
  [StringKey.NAV_FEATURES]: 'الميزات',
  [StringKey.NAV_PRICING]: 'الأسعار',
  [StringKey.NAV_FAQS]: 'الأسئلة الشائعة',
  [StringKey.NAV_CONTACT_US]: 'اتصل بنا',
  [StringKey.REQUEST_A_DEMO]: 'اطلب عرض تجريبي',

  // ContactUsSection
  [StringKey.CONTACT_US_LABEL]: 'اتصل بنا',
  [StringKey.CONTACT_US_HEADING]: 'تواصل مع فريق معازيب',
  [StringKey.CONTACT_US_SUBTITLE]: 'أسئلتك، ملاحظاتك أو أفكارك. نحن نستمع.',
  [StringKey.FIRST_NAME]: 'الاسم الأول',
  [StringKey.ENTER_FIRST_NAME]: 'أدخل الاسم الأول',
  [StringKey.LAST_NAME]: 'اسم العائلة',
  [StringKey.ENTER_LAST_NAME]: 'أدخل اسم العائلة',
  [StringKey.EMAIL]: 'البريد الإلكتروني',
  [StringKey.ENTER_EMAIL]: 'أدخل البريد الإلكتروني',
  [StringKey.INQUIRY_TYPE]: 'نوع الاستفسار',
  [StringKey.SELECT_INQUIRY_TYPE]: 'اختر نوع الاستفسار',
  [StringKey.HEARD_FROM]: 'كيف سمعت عنا؟',
  [StringKey.SELECT]: 'اختر',
  [StringKey.MESSAGE]: 'رسالة',
  [StringKey.WRITE_YOUR_MESSAGE]: 'اكتب رسالتك هنا...',
  [StringKey.AGREE_TERMS_POLICY]: 'وأنا أتفق مع',
  [StringKey.TERMS_OF_USE]: 'شروط الاستخدام',
  [StringKey.PRIVACY_POLICY]: 'سياسة الخصوصية',
  [StringKey.SUBMIT_FORM]: 'إرسال النموذج',

  // Validation messages
  [StringKey.FIRST_NAME_REQUIRED]: 'الاسم الأول مطلوب',
  [StringKey.LAST_NAME_REQUIRED]: 'اسم العائلة مطلوب',
  [StringKey.EMAIL_REQUIRED]: 'البريد الإلكتروني مطلوب',
  [StringKey.EMAIL_INVALID]: 'البريد الإلكتروني غير صالح',
  [StringKey.INQUIRY_TYPE_REQUIRED]: 'نوع الاستفسار مطلوب',
  [StringKey.HEARD_FROM_REQUIRED]: 'هذا الحقل مطلوب',
  [StringKey.MESSAGE_REQUIRED]: 'الرسالة مطلوبة',
  [StringKey.AGREE_TERMS_REQUIRED]: 'يجب الموافقة على الشروط والسياسة',
  [StringKey.CONTACT_US_SECTION]: 'اتصل بنا',
  [StringKey.AND]: 'و',

  // RequestDemoSection
  [StringKey.REQUEST_SUCCESS_TITLE]: 'تم تقديم طلبك بنجاح',
  [StringKey.REQUEST_SUCCESS_DESC]:
    'تم تقديم طلبك بنجاح. ستتلقى إشعارًا بمجرد معالجته. شكرًا على صبرك!',
  [StringKey.GOT_IT]: 'فهمت!',
  [StringKey.MAAZEEB_IN_ACTION]: 'تجربة معازيب',
  [StringKey.PERSONALIZED_DEMO_TITLE]: 'احصل على عرض توضيحي لمعازيب',
  [StringKey.DEMO_TOOLS_DESC]:
    'اكتشف كيف تبسّط أدواتنا تخطيط الفعاليات، وتعزّز التفاعل، وتجمع جميع الأدوار في منظومة واحدة سلسة.',
  [StringKey.SEE_DIFFERENCE]: 'اكتشف الفرق مع معازيب. جرّبه اليوم!',
  [StringKey.PHONE_NUMBER]: 'رقم الجوال',
  [StringKey.ENTER_PHONE_NUMBER]: 'أدخل رقم الجوال',
  [StringKey.ORGANIZATION_NAME]: 'اسم المنظمة',
  [StringKey.ENTER_ORGANIZATION_NAME]: 'أدخل اسم المنظمة',
  [StringKey.SECTOR_TYPE]: 'نوع المنظمة',
  [StringKey.SELECT_YOUR_SECTOR]: 'اختر النوع',
  [StringKey.COUNTRY]: 'الدولة',
  [StringKey.SELECT_COUNTRY]: 'اختر الدولة',

  // Validation messages (RequestDemoSection)
  [StringKey.PHONE_NUMBER_REQUIRED]: 'رقم الجوال مطلوب',
  [StringKey.ORGANIZATION_NAME_REQUIRED]: 'اسم المنظمة مطلوب',
  [StringKey.SECTOR_TYPE_REQUIRED]: 'نوع القطاع مطلوب',
  [StringKey.COUNTRY_REQUIRED]: 'الدولة مطلوبة',
  [StringKey.VENDOR]: 'بائع',
  [StringKey.SPONSOR]: 'راعي',

  [StringKey.JOIN_WAITLIST_TITLE]: 'انضم إلى قائمة الانتظار',
  [StringKey.JOIN_WAITLIST_DESC]:
    'لا تفوت الفرصة لتجربة معازيب وسجل اهتمامك الآن وسيقوم فريقنا بالتواصل معكم!',
  [StringKey.YOUR_EMAIL]: 'عنوان بريدك الإلكتروني',
  [StringKey.BEST_SUITED]: 'الأكثر ملاءمة لـ',
  [StringKey.ORGANIZERS]: 'المنظمين',
  [StringKey.VENDORS]: 'الموردين',
  [StringKey.SPONSORS]: 'الرعاة',
  [StringKey.EXHIBITORS]: 'العارضين',
  [StringKey.SPEAKERS]: 'المتحدثين',
  [StringKey.ATTENDEES]: 'الحضور',
  [StringKey.WAITLIST_MODAL_TITLE]: 'أنت على قائمة الانتظار!',
  [StringKey.WAITLIST_MODAL_DESC]:
    'شكراً لانضمامك إلى قائمة الانتظار! سنتواصل معك عندما يحين دورك.',

  [StringKey.SECTOR_TECHNOLOGY]: 'التقنية',
  [StringKey.SECTOR_FINANCE_AND_INVESTMENT]: 'المالية والاستثمار',
  [StringKey.SECTOR_ENVIRONMENTAL]: 'البيئة',
  [StringKey.SECTOR_SOCIAL_AND_CHARITY_IMPACT]: 'منظمة خيرية',
  [StringKey.SECTOR_GOVERNMENT]: 'القطاع الحكومي',
  [StringKey.SECTOR_SCIENCE_AND_EDUCATION]: 'العلوم والتعليم',
  [StringKey.SECTOR_TRAVEL_AND_TOURISM]: 'السفر والسياحة',
  [StringKey.SECTOR_MEDIA_AND_COMMUNICATIONS]: 'الإعلام والاتصالات',
  [StringKey.SECTOR_CORPORATE_AND_HUMAN_RESOURCES]: 'الشركات والموارد البشرية',
  [StringKey.SECTOR_HEALTH_AND_WELLNESS]: 'الصحة',
  [StringKey.SECTOR_SPORTS_AND_RECREATION]: 'الرياضة والترفيه',
  [StringKey.SECTOR_ART_AND_CULTURE]: 'الفن والثقافة',
  [StringKey.SECTOR_ENTERTAINMENT_AND_EVENT_MANAGEMENT]: 'الترفيه وإدارة الفعاليات',
  [StringKey.SECTOR_OTHER]: 'أخرى',

  [StringKey.INQUIRY_GENERAL]: 'استفسار عام',
  [StringKey.INQUIRY_DEMO_REQUEST]: 'طلب تجريبي للنظام',
  [StringKey.INQUIRY_TECHNICAL_SUPPORT]: 'الدعم الفني',
  [StringKey.INQUIRY_SUBSCRIPTION_AND_PRICING]: 'الاشتراك والتسعير',
  [StringKey.INQUIRY_PARTNERSHIP_OPPORTUNITIES]: 'فرص الشراكة',
  [StringKey.INQUIRY_SPONSORSHIP_DEALS]: 'صفقات الرعاية',
  [StringKey.INQUIRY_VENDOR_REGISTRATION]: 'تسجيل البائعين',
  [StringKey.INQUIRY_MEDIA_AND_PR]: 'استفسارات وسائل الإعلام والعلاقات العامة',
  [StringKey.INQUIRY_EVENT_MANAGEMENT_SERVICES]: 'خدمات إدارة الأحداث',
  [StringKey.INQUIRY_FEEDBACK_OR_SUGGESTIONS]: 'ملاحظات أو اقتراحات',
  [StringKey.INQUIRY_INVESTOR_RELATIONS]: 'علاقات المستثمرين',
  [StringKey.INQUIRY_OTHER]: 'أخرى',

  [StringKey.HEARD_FROM_GEA]: 'الهيئة العامة للترفيه',
  [StringKey.HEARD_FROM_INCUBATORS_AND_ACCELERATORS]: 'حاضنات ومسرعات الترفيه',
  [StringKey.HEARD_FROM_PLUG_AND_PLAY]: 'Plug & Play',
  [StringKey.HEARD_FROM_SOCIAL_MEDIA]: 'وسائل التواصل الاجتماعي (Instagram، X، LinkedIn، إلخ.)',
  [StringKey.HEARD_FROM_FRIEND_OR_COLLEAGUE]: 'صديق أو زميل',
  [StringKey.HEARD_FROM_EVENT_OR_EXHIBITION]: 'حدث أو معرض',
  [StringKey.HEARD_FROM_ONLINE_SEARCH]: 'البحث عبر الإنترنت (Google)',
  [StringKey.HEARD_FROM_OTHER]: 'أخرى',

  [StringKey.TOAST_ERROR_TITLE]: 'حدث خطأ ما',
  [StringKey.TOAST_ERROR_DESC]:
    'حدثت مشكلة أثناء إرسال نموذجك. يُرجى التحقق من اتصالك أو المحاولة مرة أخرى بعد بضع دقائق.',
  [StringKey.MESSAGE_SENT]: 'تم إرسال الرسالة بنجاح!',
  [StringKey.MESSAGE_SENT_DESC]: 'شكرًا لرسالتك! سيتواصل فريقنا معك في أقرب وقت ممكن.',

  [StringKey.YOU_ARE_ALL_SET_MSG]: 'أنت جاهز تماما',
  [StringKey.TOO_MANY_REQUESTS_MSG]: 'عدد كبير جدًا من الطلبات، يرجى المحاولة مرة أخرى لاحقًا.',
  [StringKey.BACK]: 'خلف',

  //Terms of Use and Privacy policy
  [StringKey.TERMS_TITLE]: 'معازيب نظام استخدام شروط',
  [StringKey.TERMS_LAST_UPDATED]: 'آخر تحديث:',
  [StringKey.TERMS_ACCEPTANCE_TITLE]: 'قبول الشروط القانونية',
  [StringKey.TERMS_ACCEPTANCE_P1]:
    'تُعد هذه الشروط والأحكام ("الشروط") اتفاقية ملزمة قانونًا بين المستخدم وشركة ميتكولس سولوشنز، وهي كيان سعودي يملك ويُشغّل النظام الرقمي المعروف باسم "معازيب"، وهو نظام إلكتروني وسيط مرخّص في المملكة العربية السعودية يُسهّل إدارة الفعاليات بين منظمي الفعاليات وأصحاب المصلحة (ويُشار إليه فيما بعد بـ"النظام").',
  [StringKey.TERMS_ACCEPTANCE_P2]:
    'يخضع استخدام النظام لأنظمة المملكة العربية السعودية، بما في ذلك نظام التجارة الإلكترونية ولوائحه التنفيذية، ونظام حماية البيانات الشخصية (PDPL).يرجى قراءة هذه الشروط بعناية. باستخدامك للنظام أو بإنشائك حسابًا، فإنك تقر بأنك قد قرأت هذه الشروط وفهمتها وتوافق على الالتزام بها، وأنك لا تقل عن 18 عامًا وتتمتع بالأهلية القانونية للدخول في عقود ملزمة وفقًا للأنظمة المعمول بها.',
  [StringKey.TERMS_ACCEPTANCE_P3]:
    'في حال عدم موافقتك على هذه الشروط، يُحظر عليك استخدام النظام ويجب عليك التوقف عن استخدامه فورًا.يجوز لمعازيب تعديل هذه الشروط أو تعديل الرسوم أو تغيير الخدمات بعد إشعار مسبق عبر البريد الإلكتروني أو من خلال النظام. وتدخل التعديلات حيز التنفيذ بعد 14 يومًا من الإشعار، ويُعد استمرارك في الاستخدام قبولًا للتعديل.',
  [StringKey.TERMS_DEFINITIONS_TITLE]: 'التعريفات',
  [StringKey.TERMS_DEFINITIONS_SYSTEM]:
    'النظام: نظام معازيب – نظام إلكتروني وسيط مرخّص في المملكة العربية السعودية يُسهّل إدارة الفعاليات بين منظمي الفعاليات وأصحاب المصلحة، بما في ذلك الرعاة، العارضين، المورّدين، المتحدثين، والحضور/الزوار.ويجب أن يُظهر النظام بياناته التعريفية على واجهته، بما في ذلك اسم المشغل، عنوانه، قنوات الاتصال، سياسة الخصوصية، رقم السجل التجاري، والرقم الضريبي (إن وجد).',
  [StringKey.TERMS_DEFINITIONS_USER]:
    'المستخدم: أي شخص طبيعي أو اعتباري يستخدم النظام، سواء بصفته منظمًا، راعيًا، عارضًا، مورّدًا، متحدثًا، أو زائرًا/حاضرًا.',
  [StringKey.TERMS_DEFINITIONS_ORGANIZER]:
    'المنظّم: شخص أو جهة تنشئ أو تدير الفعاليات وتنشر نطاق العمل من خلال النظام لتلقي عروض المشاركة أو التعاون من الرعاة أو العارضين أو المورّدين أو المتحدثين.',
  [StringKey.TERMS_DEFINITIONS_SPONSOR]:
    'الراعي: شخص أو جهة تقدم رعاية مالية أو عينية للفعاليات أو المشاريع التي تُنظم عبر النظام.',
  [StringKey.TERMS_DEFINITIONS_EXHIBITOR]:
    'العارض: شخص أو جهة تعرض أو تبيع منتجات أو خدمات ضمن الفعاليات والمعارض من خلال النظام.',
  [StringKey.TERMS_DEFINITIONS_VENDOR]:
    'المورّد: شخص أو جهة تقدم خدمات أو منتجات لدعم تنفيذ الفعاليات من خلال النظام، بما في ذلك خدمات الإنتاج، اللوجستيات، التقنية، الضيافة وغيرها.',
  [StringKey.TERMS_DEFINITIONS_SPEAKER]:
    'المتحدث: شخص يُقدّم محاضرات أو حوارات أو ورش عمل أو عروضًا فنية من خلال النظام ضمن الفعاليات التي يديرها المنظمون.',
  [StringKey.TERMS_DEFINITIONS_ATTENDEE_VISITOR]:
    'الحضور / الزوار: أي فرد يقوم بالتسجيل أو شراء التذاكر أو حضور الفعاليات المُدارة عبر النظام.',
  [StringKey.TERMS_REGISTRATION_TITLE]: 'التسجيل واستخدام النظام',
  [StringKey.TERMS_REGISTRATION_REQUIREMENTS]:
    'متطلبات التسجيل: يجب على المستخدم إنشاء حساب وتقديم معلومات صحيحة ومحدثة، بما في ذلك الاسم الكامل، بيانات الاتصال، والسجل التجاري أو الترخيص المهني حسب الاقتضاء. ويجوز للنظام طلب وثائق إضافية (مثل التراخيص أو السجلات التجارية) للتحقق من الأهلية.يجوز لمعازيب قبول أو رفض طلبات التسجيل أو تعليق الحساب في حال وجود مخالفة أو تقديم بيانات غير دقيقة.',
  [StringKey.TERMS_USER_ELIGIBILITY]:
    'أهلية المستخدم: باستخدامك للنظام، فإنك تُقر بأنك تتمتع بالأهلية القانونية (18 عامًا فأكثر) وأنك غير ممنوع من استخدام الخدمات الإلكترونية بموجب أي نظام أو لائحة في المملكة.',
  [StringKey.TERMS_ELECTRONIC_COMMUNICATIONS]:
    'الاتصالات الإلكترونية: إن استخدامك للنظام وإرسالك للبريد الإلكتروني أو الرسائل النصية يُعد اتصالًا إلكترونيًا، وتوافق على أن جميع الاتفاقيات والإشعارات والإفصاحات وغيرها من المراسلات التي نقدمها إلكترونيًا تُعد مستوفية لأي متطلب قانوني للكتابة. كما توافق على استخدام التوقيعات والعقود والسجلات الإلكترونية.',
  [StringKey.TERMS_DATA_UPDATES]:
    'تحديث البيانات: يجب على المستخدم المحافظة على دقة البيانات وتحديثها فور حدوث أي تغيير. ويجوز لمعازيب تعليق أو إلغاء الحساب في حال تقديم بيانات غير دقيقة أو مخالفة الأنظمة المعمول بها.',
  [StringKey.TERMS_SUBSCRIPTIONS_TITLE]: 'الاشتراكات والرسوم',
  [StringKey.TERMS_ORGANIZER_SUBSCRIPTION]:
    'اشتراك المنظّم: يلتزم المنظم بدفع اشتراك شهري أو سنوي وفقًا للباقات المختارة، ويُدفع مقدمًا وغير قابل للاسترداد بعد بدء الاستخدام، ما لم يُلغَ خلال فترة التجربة المجانية (إن وجدت). ويتحمل المنظم الضرائب الحكومية بما فيها ضريبة القيمة المضافة على الاشتراك.',
  [StringKey.TERMS_TRANSACTION_COMMISSIONS]:
    'عمولات المعاملات: يفرض النظام عمولة على مبيعات التذاكر أو المعاملات المشابهة بنسبة محددة من الإيرادات الناتجة عبر النظام. كما تُستحق عمولة منفصلة على العقود المبرمة بين المنظم وكل من الرعاة أو العارضين أو المورّدين أو المتحدثين، وتختلف نسب العمولات حسب الفئة.يجب سداد العمولات خلال 15 يومًا من تاريخ انتهاء الفعالية أو تقديم الخدمة. وإذا تم تحويل الأموال مباشرة بين الأطراف، تبقى العمولة مستحقة ويجب سدادها خلال المدة المحددة.',
  [StringKey.TERMS_VENDOR_SPONSOR_FEES]:
    'رسوم المورّدين/الرعاة/العارضين/المتحدثين: التسجيل مجاني، لكن تُستحق عمولات رمزية عند إبرام العقود عبر النظام. ويتحمل الأطراف الضرائب والرسوم الحكومية المطبقة.',
  [StringKey.TERMS_PAYMENT_METHODS]:
    'طرق الدفع: يدعم النظام المدفوعات الإلكترونية باستخدام بطاقات الائتمان، بطاقات مدى، والتحويلات البنكية. ويُقر المستخدم بتقديم معلومات دفع دقيقة ويُفوّض النظام بتحصيل الرسوم والعمولات والضرائب المستحقة.يجوز لمعازيب تصحيح أي خطأ في الأسعار أو الرسوم حتى بعد إتمام العملية. وفي حال عدم السداد، يحق لمعازيب تعليق الحساب أو إنهاؤه.',
  [StringKey.TERMS_TENDERING_TITLE]: 'نظام المناقصات والتعاقد من خلال النظام',
  [StringKey.TERMS_TENDERING_P1]:
    'يُمكّن النظام المنظّم من نشر نطاق العمل للفعاليات أو المشاريع، ويجوز للرعاة والعارضين والمورّدين والمتحدثين تقديم العروض الفنية والمالية عبر النظام.',
  [StringKey.TERMS_TENDERING_P2]:
    'يجب على المستخدمين تقديم عروضهم خلال المواعيد المحددة ووفقًا للشروط الفنية المطلوبة. ويجوز للمنظّم تقييم العروض وترسيتها على المشارك الأنسب من حيث الجودة أو السعر أو القيمة المضافة.',
  [StringKey.TERMS_TENDERING_P3]:
    'بمجرد قبول العرض عبر النظام، يصبح الاتفاق ملزمًا للطرفين، ويجب تنفيذ الالتزامات وفقًا للشروط التعاقدية. ويُحظر على المستخدمين التواصل خارج النظام بغرض إبرام العقد أو التهرب من سداد العمولة.',
  [StringKey.TERMS_PAYMENTS_TITLE]: 'المدفوعات والفواتير',
  [StringKey.TERMS_PAYMENTS_P1]:
    'يدير النظام عمليات الدفع الإلكتروني؛ وفي حال تحويل الأموال مباشرة بين المنظم وطرف آخر، يجب على الأطراف إخطار معازيب وسداد العمولة خلال 15 يومًا.',
  [StringKey.TERMS_PAYMENTS_P2]:
    'يُصدر النظام فواتير إلكترونية بالرسوم والعمولات المستحقة ويرسلها إلى المستخدم عبر البريد الإلكتروني أو الحساب الخاص به.',
  [StringKey.TERMS_PAYMENTS_P3]:
    'يجوز لمعازيب تعليق أو إنهاء الحساب في حال تأخر المستخدم عن سداد المبالغ المستحقة.',
  [StringKey.TERMS_PAYMENTS_P4]:
    'إن حذف أو إلغاء تنشيط الحساب لا يُعفي المستخدم من الالتزامات المالية المتعلقة بالمعاملات أو العمولات أو العقود المبرمة من خلال النظام قبل الحذف أو الإلغاء.',
  [StringKey.TERMS_INTELLECTUAL_PROPERTY_TITLE]: 'الملكية الفكرية وعدم المنافسة',
  [StringKey.TERMS_INTELLECTUAL_PROPERTY_P1]:
    'جميع حقوق الملكية الفكرية في النظام – بما في ذلك البرمجيات، وقواعد البيانات، والتصاميم، والنصوص، والشعارات، والرسومات – مملوكة لمعازيب أو للمرخّصين لها، ومحميّة بموجب أنظمة المملكة.ويمنح النظام المستخدم ترخيصًا محدودًا وغير حصري وغير قابل للتحويل للوصول إلى الخدمات واستخدامها لأغراض مشروعة تتعلق بالفعاليات فقط.',
  [StringKey.TERMS_INTELLECTUAL_PROPERTY_P2]:
    'لا يجوز للمستخدم نسخ أو إعادة إنتاج أو تعديل أو بيع أو استغلال أي جزء من النظام أو محتواه أو علاماته التجارية لأي غرض تجاري دون موافقة خطية مسبقة. كما يُحظر استخدام العلامات أو المحتوى بطريقة تضر بالنظام أو بالغير.',
  [StringKey.TERMS_INTELLECTUAL_PROPERTY_P3]:
    'ويوافق المستخدمون، خلال فترة استخدام النظام ولمدة تصل إلى 12 شهرًا بعد انتهائها، على عدم إنشاء أو تشغيل أو دعم أي نظام منافس يعتمد على الأسرار التجارية أو المعلومات التي تم الحصول عليها من خلال النظام.',
  [StringKey.TERMS_PROHIBITED_ACTIVITIES_TITLE]: 'الأنشطة المحظورة',
  [StringKey.TERMS_PROHIBITED_ACTIVITIES_P1]:
    'يُحظر على المستخدمين استخدام النظام لأي أغراض غير مشروعة أو مخالفة لأنظمة المملكة، بما في ذلك على سبيل المثال لا الحصر:',
  [StringKey.TERMS_PROHIBITED_ACTIVITIES_BULLET1]:
    '• جمع بيانات المستخدمين الآخرين أو استغلالها خارج النظام دون تفويض.',
  [StringKey.TERMS_PROHIBITED_ACTIVITIES_BULLET2]:
    '• نشر أو تحميل محتوى غير قانوني أو مسيء أو مضلل أو منتهك لحقوق الملكية الفكرية أو الخصوصية.',
  [StringKey.TERMS_PROHIBITED_ACTIVITIES_BULLET3]:
    '• تجاوز أو تعطيل تدابير الأمان، أو التدخل في التشغيل، أو محاولة الوصول غير المصرح به.',
  [StringKey.TERMS_PROHIBITED_ACTIVITIES_BULLET4]:
    '• استخدام الوسائل الآلية مثل الروبوتات لاستخراج المعلومات أو إرسال الرسائل العشوائية أو تنفيذ عمليات احتيالية.',
  [StringKey.TERMS_PROHIBITED_ACTIVITIES_BULLET5]:
    '• انتحال هوية مستخدم آخر أو تقديم معلومات كاذبة أو غير دقيقة.',
  [StringKey.TERMS_PROHIBITED_ACTIVITIES_BULLET6]:
    '• التواصل خارج النظام لإبرام عقد أو التهرب من سداد العمولة أو الاطلاع على عروض المنافسين.',
  [StringKey.TERMS_PROHIBITED_ACTIVITIES_BULLET7]:
    '• بيع أو نقل الحساب أو استخدام النظام للمنافسة مع معازيب أو الإعلان عن منتجات أو خدمات غير ذات صلة دون إذن.',
  [StringKey.TERMS_PRIVACY_TITLE]: 'الخصوصية',
  [StringKey.TERMS_PRIVACY_P1]:
    'يخضع جمع ومعالجة البيانات الشخصية لسياسة الخصوصية المعتمدة لدينا، والمتوافقة مع نظام حماية البيانات الشخصية ولوائحه التنفيذية.يرجى مراجعتها بعناية، إذ تُعد جزءًا لا يتجزأ من هذه الشروط بالإحالة.',
  [StringKey.TERMS_TERM_TERMINATION_TITLE]: 'المدة وإنهاء الاستخدام',
  [StringKey.TERMS_TERM_TERMINATION_P1]:
    'تسري هذه الشروط من تاريخ قبول المستخدم لها وتستمر طوال فترة استخدام النظام.يجوز لأي طرف إنهاء الاتفاق بإشعار خطي للطرف الآخر وفقًا للباقات والفئات، على أن تتم تسوية جميع الالتزامات المالية قبل الإنهاء.',
  [StringKey.TERMS_TERM_TERMINATION_P2]:
    'يجوز لمعازيب تعليق أو إلغاء الحساب أو إنهاء هذه الشروط فورًا دون إشعار إذا خالف المستخدم أي حكم من أحكامها أو أساء استخدام النظام أو خالف أي نظام أو لائحة.وبعد الإنهاء، يُحظر على المستخدم إعادة التسجيل أو الوصول إلى النظام باسم آخر. وتحتفظ معازيب بحقها في اتخاذ الإجراءات القانونية المناسبة.',
  [StringKey.TERMS_TERM_TERMINATION_P3]:
    'لا يؤثر الإنهاء على الحقوق والالتزامات المكتسبة قبل تاريخ الإنهاء، مثل العمولات المستحقة أو الالتزامات المالية أو الضمانات أو التعويضات.',
  [StringKey.TERMS_TERM_TERMINATION_P4]:
    'إن تعليق الحساب أو حذفه أو إنهاءه لا يُلغي أو يتنازل عن حق معازيب في تحصيل أي عمولات أو رسوم خدمات أو التزامات مالية مستحقة على المستخدم.',
  [StringKey.TERMS_TERM_TERMINATION_P5]:
    'وفي حال قام المنظم أو المورّد أو أي مستخدم آخر بحذف حسابه، تحتفظ معازيب بالحق في المطالبة بالمبالغ المستحقة من خلال أي وسيلة قانونية أو إدارية متاحة.',
  [StringKey.TERMS_TERM_TERMINATION_P6]:
    'كما تحتفظ معازيب بالحق في تعليق أو تقييد أو حذف أي حساب يثبت محاولته التهرب من السداد أو إساءة استخدام النظام، دون الإخلال بحقها في المطالبة بجميع المبالغ المستحقة والتعويضات.',
  [StringKey.TERMS_CHANGES_INTERRUPTS_TITLE]: 'التغييرات والانقطاعات',
  [StringKey.TERMS_CHANGES_INTERRUPTS_P1]:
    'يجوز لمعازيب تعديل أو تغيير أو إزالة أجزاء من النظام أو تعليق الخدمات لأي سبب وفقًا لتقديرها ودون التزام بتحديث المعلومات، شريطة إخطار المستخدمين بالتغييرات في الشروط أو الرسوم قبل 14 يومًا من سريانها.',
  [StringKey.TERMS_CHANGES_INTERRUPTS_P2]:
    'وقد يواجه النظام انقطاعات أو توقفًا بسبب الصيانة أو ظروف القوة القاهرة، ولا تتحمل معازيب أي مسؤولية عن عدم القدرة على الوصول إلى النظام خلال تلك الفترات، مع التزامها ببذل الجهود المعقولة لاستعادة الخدمة في أقرب وقت ممكن.',
  [StringKey.TERMS_DISCLAIMER_TITLE]: 'إخلاء المسؤولية وتحديد المسؤولية',
  [StringKey.TERMS_DISCLAIMER_P1]:
    'يُقدَّم النظام والخدمات "كما هي" و"حسب التوفر" دون أي ضمانات صريحة أو ضمنية.ولا تضمن معازيب دقة المعلومات أو خلوها من الأخطاء أو الفيروسات، ولا تتحمل أي مسؤولية عن الأضرار الناتجة عن استخدام النظام أو الاعتماد عليه.',
  [StringKey.TERMS_DISCLAIMER_P2]:
    'ولا تتحمل معازيب أو مديروها أو موظفوها أو وكلاؤها أي مسؤولية عن الأضرار المباشرة أو غير المباشرة أو التبعية أو الخاصة أو الجزائية، بما في ذلك فقدان الأرباح أو البيانات، الناتجة عن استخدام النظام أو عدم القدرة على استخدامه.وفي جميع الحالات، تُحدّد مسؤولية معازيب تجاه المستخدم بالمبالغ الفعلية المدفوعة عن الخدمات محل النزاع فقط.',
  [StringKey.TERMS_DISCLAIMER_P3]:
    'ولا تتحمل معازيب مسؤولية المحتوى أو الخدمات المقدمة من المستخدمين أو الأطراف الثالثة عبر النظام، ولا تضمن جودة أو قانونية تلك الخدمات، إذ يتحمل جميع الأطراف مسؤولية التزاماتهم التعاقدية.',
  [StringKey.TERMS_INDEMNIFICATION_TITLE]: 'التعويض',
  [StringKey.TERMS_INDEMNIFICATION_P1]:
    'يوافق المستخدم على الدفاع وتعويض وحماية معازيب وشركاتها التابعة وموظفيها ووكلائها وشركائها من أي خسائر أو أضرار أو مطالبات أو تكاليف (بما في ذلك أتعاب المحاماة) تنشأ عن:(1) استخدام المستخدم للنظام أو مخالفته لهذه الشروط،(2) مخالفته لأي نظام أو لائحة،(3) انتهاكه لحقوق أي طرف ثالث، أو(4) أي محتوى يقدمه من خلال النظام.وتحتفظ معازيب بحقها – على نفقة المستخدم – في تولي الدفاع والسيطرة الحصرية على أي قضية تخضع للتعويض، ويلتزم المستخدم بالتعاون الكامل في هذا الدفاع.',
  [StringKey.TERMS_GOVERNING_LAW_TITLE]: 'القانون الواجب التطبيق وتسوية المنازعات',
  [StringKey.TERMS_GOVERNING_LAW_P1]:
    'تخضع هذه الشروط وتُفسر وفقًا للأنظمة واللوائح المعمول بها في المملكة العربية السعودية.ويتفق الطرفان على محاولة تسوية أي نزاع وديًا خلال فترة زمنية معقولة، وفي حال تعذر ذلك، تُحال المنازعة إلى المحاكم المختصة في المملكة العربية السعودية التي تتمتع بالاختصاص الحصري.',
  [StringKey.TERMS_GENERAL_PROVISIONS_TITLE]: 'الأحكام العامة',
  [StringKey.TERMS_GENERAL_PROVISIONS_P1]:
    'تُشكّل هذه الشروط وسياسة الخصوصية وأي شروط أو اتفاقيات إضافية منشورة على النظام الاتفاق الكامل بين معازيب والمستخدم.',
  [StringKey.TERMS_GENERAL_PROVISIONS_P2]:
    'إذا تبيّن أن أي حكم غير قانوني أو غير قابل للتنفيذ، يُعتبر ذلك الحكم قابلاً للفصل دون أن يؤثر على سريان باقي الأحكام.',
  [StringKey.TERMS_GENERAL_PROVISIONS_P3]:
    'لا يُعد تأخر أو امتناع معازيب عن ممارسة أي حق تنازلًا عنه. ولا يجوز للمستخدم التنازل عن حقوقه أو التزاماته دون موافقة خطية من معازيب، بينما يجوز لمعازيب التنازل عن حقوقها أو التزاماتها لطرف آخر.',
  [StringKey.TERMS_GENERAL_PROVISIONS_P4]:
    'وفي حالة القوة القاهرة (مثل الكوارث الطبيعية أو الأوبئة أو القرارات الحكومية التي تمنع التنفيذ)، لا يتحمل أي طرف المسؤولية عن عدم التنفيذ طالما تم بذل الجهود المعقولة لتخفيف الآثار السلبية.',
  [StringKey.TERMS_GENERAL_PROVISIONS_P5]:
    'يمكنك التواصل مع معازيب لأي استفسارات أو شكاوى عبر قنوات الاتصال الموضحة على النظام، وستُعالج الشكاوى وفقًا للسياسات المعتمدة ونظام حماية البيانات الشخصية.',
  [StringKey.TERMS_LANGUAGE_TITLE]: 'اللغة السائدة وبيانات الشركة الرسمية',
  [StringKey.TERMS_LANGUAGE_P1]:
    'لغة الاتفاق: تم إعداد هذه الشروط باللغتين العربية والإنجليزية، وفي حال وجود أي تعارض بين النصين، تُعتمد النسخة العربية وتُعتبر هي المرجع القانوني والملزم.',
  [StringKey.PRIVACY_TITLE]: 'معازيب لنظام الخصوصية سياسة',
  [StringKey.PRIVACY_WHO_WE_ARE_TITLE]: 'من نحن ونطاق السياسة',
  [StringKey.PRIVACY_DATA_CONTROLLER]:
    'المتحكم في البيانات: شركة ميتِكولس سولوشنز، وهي كيان سعودي يملك ويشغّل النظام الرقمي المعروف باسم "معازيب"، وهو نظام إلكتروني وسيط مرخّص في المملكة العربية السعودية يسهّل إدارة الفعاليات بين منظمي الفعاليات وأصحاب المصلحة (ويُشار إليه فيما بعد بـ “النظام”).',
  [StringKey.PRIVACY_POLICY_APPLIES]:
    'تنطبق هذه السياسة على معالجة البيانات الشخصية الخاصة بالمستخدمين داخل المملكة وخارجها كلما كانت البيانات تتعلق بأفراد داخل المملكة، وذلك وفقًا لنظام حماية البيانات الشخصية (PDPL) ولوائحه التنفيذية.',
  [StringKey.PRIVACY_LEGAL_BASES_TITLE]: 'الأسس النظامية لمعالجة البيانات',
  [StringKey.PRIVACY_LEGAL_BASES_P1]:
    'نقوم بمعالجة البيانات الشخصية استنادًا إلى الأسس النظامية التالية:',
  [StringKey.PRIVACY_LEGAL_BASES_A]: 'أ) تنفيذ عقد وتقديم خدمات النظام؛',
  [StringKey.PRIVACY_LEGAL_BASES_B]:
    'ب) الالتزام النظامي، للامتثال للأنظمة واللوائح السعودية المعمول بها؛',
  [StringKey.PRIVACY_LEGAL_BASES_C]:
    'ج) المصالح المشروعة، مع موازنتها مع حقوق أصحاب البيانات، مثل ضمان الأمان، ومنع الاحتيال، وتحسين النظام؛',
  [StringKey.PRIVACY_LEGAL_BASES_D]:
    'د) الموافقة الصريحة، ولا سيما لأغراض التسويق الإلكتروني أو أي معالجة أخرى تتطلب موافقة بموجب نظام حماية البيانات الشخصية.',
  [StringKey.PRIVACY_DATA_WE_COLLECT_TITLE]: 'البيانات التي نجمعها',
  [StringKey.PRIVACY_DATA_WE_COLLECT_P1]: 'نجمع الفئات التالية من البيانات:',
  [StringKey.PRIVACY_DATA_IDENTITY_CONTACT]:
    '•	بيانات الهوية ووسائل الاتصال، مثل الاسم ورقم الهاتف والبريد الإلكتروني وتفاصيل الهوية الوطنية أو السجل التجاري؛',
  [StringKey.PRIVACY_DATA_BUSINESS]:
    '•	البيانات التجارية الخاصة بالجهات الاعتبارية التي تستخدم النظام؛',
  [StringKey.PRIVACY_DATA_ACCOUNT_USAGE]:
    '•	بيانات الحساب والاستخدام والبيانات التقنية، مثل عنوان بروتوكول الإنترنت (IP) ونوع المتصفح ومعرّفات الأجهزة؛',
  [StringKey.PRIVACY_DATA_MARKETING]: '•	تفضيلات التسويق وإعدادات التواصل؛',
  [StringKey.PRIVACY_DATA_PAYMENT]:
    '•	بيانات الدفع التي تتم معالجتها من خلال مزوّدي الدفع المرخصين في المملكة العربية السعودية؛',
  [StringKey.PRIVACY_DATA_CONTRACTING]: '•	بيانات التعاقد والمناقصات التي تتم معالجتها ضمن النظام.',
  [StringKey.PRIVACY_HOW_WE_COLLECT_TITLE]: 'كيفية جمع البيانات',
  [StringKey.PRIVACY_HOW_WE_COLLECT_P1]: 'نقوم بجمع البيانات الشخصية من خلال:',
  [StringKey.PRIVACY_HOW_DIRECT_INTERACTIONS]:
    '•	التفاعلات المباشرة أثناء التسجيل أو التعاقد أو استخدام ميزات النظام ونماذج الطلب؛',
  [StringKey.PRIVACY_HOW_AUTOMATED]:
    '•	الوسائل الآلية، مثل ملفات تعريف الارتباط (Cookies) وتقنيات التحليل التي ترصد النشاط ومؤشرات الأداء؛',
  [StringKey.PRIVACY_HOW_THIRD_PARTIES]:
    '•	الأطراف الثالثة، بما في ذلك بوابات الدفع ومزوّدي الاستضافة وشركاء التكامل أو التحليل، ضمن أطر قانونية وتعاقدية.',
  [StringKey.PRIVACY_PURPOSES_TITLE]: 'أغراض المعالجة',
  [StringKey.PRIVACY_PURPOSES_P1]: 'نقوم بمعالجة البيانات الشخصية للأغراض التالية:',
  [StringKey.PRIVACY_PURPOSE_OPERATING_ACCOUNTS]:
    '•	تشغيل حسابات المستخدمين وإدارة الوصول إلى النظام؛',
  [StringKey.PRIVACY_PURPOSE_MANAGING_OFFERS]:
    '•	إدارة العروض والتذاكر والعقود المتعلقة بالفعاليات؛',
  [StringKey.PRIVACY_PURPOSE_PROCESSING_PAYMENTS]: '•	معالجة المدفوعات والفوترة؛',
  [StringKey.PRIVACY_PURPOSE_CUSTOMER_SUPPORT]: '•	تقديم الدعم الفني والمساعدة للعملاء؛',
  [StringKey.PRIVACY_PURPOSE_IMPROVING_SYSTEM]: '•	تحسين النظام والتحليلات والأداء؛',
  [StringKey.PRIVACY_PURPOSE_SECURITY]: '•	ضمان أمن المعلومات ومنع الاحتيال؛',
  [StringKey.PRIVACY_PURPOSE_MARKETING]: '•	تنفيذ الاتصالات التسويقية (بموافقة مسبقة)؛',
  [StringKey.PRIVACY_PURPOSE_COMPLIANCE]:
    '•	الامتثال لمتطلبات التجارة الإلكترونية والشفافية في المتاجر وصفحات العروض.',
  [StringKey.PRIVACY_MARKETING_MESSAGES_TITLE]: 'التسويق والرسائل',
  [StringKey.PRIVACY_MARKETING_MESSAGES_P1]:
    'نرسل الرسائل التسويقية أو الترويجية فقط بعد الحصول على موافقة مسبقة من المستخدم.',
  [StringKey.PRIVACY_MARKETING_MESSAGES_P2]:
    'تتضمن جميع الرسائل آلية إلغاء الاشتراك (Opt-out) الواضحة التي تتيح للمستخدم سحب موافقته في أي وقت.',
  [StringKey.PRIVACY_MARKETING_MESSAGES_P3]:
    'تلتزم معازيب بلوائح مكافحة الرسائل غير المرغوب فيها الصادرة عن هيئة الاتصالات والفضاء والتقنية (CST).',
  [StringKey.PRIVACY_COOKIES_TITLE]: 'ملفات تعريف الارتباط',
  [StringKey.PRIVACY_COOKIES_P1]:
    'يستخدم النظام ملفات تعريف الارتباط لتحسين الأداء وتعزيز الأمان وتحليل الاستخدام وتخصيص تجربة المستخدم.',
  [StringKey.PRIVACY_COOKIES_P2]:
    'يمكن للمستخدم إدارة تفضيلاته الخاصة بملفات تعريف الارتباط من خلال إعدادات المتصفح أو مركز تفضيلات ملفات الارتباط في النظام.',
  [StringKey.PRIVACY_DATA_SHARING_TITLE]: 'مشاركة البيانات',
  [StringKey.PRIVACY_DATA_SHARING_P1]: 'تشارك معازيب الحد الأدنى اللازم من البيانات الشخصية مع:',
  [StringKey.PRIVACY_DATA_SHARING_PAYMENT_PROCESSORS]:
    '•	مزوّدي خدمات الدفع المرخصين ومزوّدي خدمات الاستضافة وشركاء التكامل الرقمي؛',
  [StringKey.PRIVACY_DATA_SHARING_CONTRACTING_PARTIES]:
    '•	أطراف التعاقد وأصحاب المصلحة المشاركين في إدارة الفعاليات ضمن النظام؛',
  [StringKey.PRIVACY_DATA_SHARING_AUTHORITIES]:
    '•	الجهات التنظيمية أو القضائية المختصة عندما يُطلب ذلك نظامًا.',
  [StringKey.PRIVACY_DATA_SHARING_P2]:
    'ولا تقوم معازيب ببيع البيانات الشخصية في أي حال من الأحوال.',
  [StringKey.PRIVACY_CROSS_BORDER_TITLE]: 'نقل البيانات عبر الحدود',
  [StringKey.PRIVACY_CROSS_BORDER_P1]: 'يجوز نقل البيانات الشخصية خارج المملكة فقط عندما:',
  [StringKey.PRIVACY_CROSS_BORDER_BULLET1]:
    '•	يكون النقل خاضعًا لضمانات وأطر حماية معتمدة ومتوافقة مع نظام حماية البيانات الشخصية (PDPL)؛',
  [StringKey.PRIVACY_CROSS_BORDER_BULLET2]:
    '•	يتم تنفيذ الالتزامات التعاقدية المناسبة وإجراء تقييمات للمخاطر؛',
  [StringKey.PRIVACY_CROSS_BORDER_BULLET3]:
    '•	يكون النقل ضروريًا لتقديم الخدمات أو تنفيذ عقد مع المستخدم.',
  [StringKey.PRIVACY_INFORMATION_SECURITY_TITLE]: 'أمن المعلومات',
  [StringKey.PRIVACY_INFORMATION_SECURITY_P1]:
    'تُطبّق معازيب تدابير إدارية وتقنية وتنظيمية لحماية البيانات الشخصية من الوصول غير المصرّح به أو سوء الاستخدام أو الفقد أو التغيير أو المعالجة غير القانونية.',
  [StringKey.PRIVACY_INFORMATION_SECURITY_P2]: 'وتشمل هذه التدابير ما يلي:',
  [StringKey.PRIVACY_INFORMATION_SECURITY_ACCESS_CONTROLS]:
    '•	ضوابط الوصول وإجراءات التحقق من الهوية؛',
  [StringKey.PRIVACY_INFORMATION_SECURITY_ENCRYPTION]: '•	التشفير وحماية البيانات أثناء الإرسال؛',
  [StringKey.PRIVACY_INFORMATION_SECURITY_LOGGING]:
    '•	التسجيل والمراقبة والاختبارات الدورية للأمان.',
  [StringKey.PRIVACY_RETENTION_TITLE]: 'الاحتفاظ بالبيانات وإتلافها',
  [StringKey.PRIVACY_RETENTION_P1]:
    'تُحتفظ البيانات الشخصية فقط للمدة اللازمة لتحقيق الأغراض التي جُمعت من أجلها أو للامتثال للالتزامات النظامية.',
  [StringKey.PRIVACY_RETENTION_P2]:
    'وبعد ذلك، ستقوم معازيب بإتلاف البيانات أو إزالة هويتها بطريقة آمنة وفقًا للوائح التنفيذية لنظام حماية البيانات الشخصية.',
  [StringKey.PRIVACY_YOUR_RIGHTS_TITLE]: 'حقوقك',
  [StringKey.PRIVACY_YOUR_RIGHTS_P1]: 'بموجب نظام حماية البيانات الشخصية، يحق لك ما يلي:',
  [StringKey.PRIVACY_YOUR_RIGHTS_ACCESS]: '•	الوصول إلى بياناتك الشخصية والحصول على نسخة منها؛',
  [StringKey.PRIVACY_YOUR_RIGHTS_RECTIFY]: '•	تصحيح المعلومات غير الدقيقة أو غير المكتملة؛',
  [StringKey.PRIVACY_YOUR_RIGHTS_RESTRICT]: '•	تقييد المعالجة في ظروف معينة؛',
  [StringKey.PRIVACY_YOUR_RIGHTS_OBJECT_MARKETING]: '•	الاعتراض على التسويق المباشر؛',
  [StringKey.PRIVACY_YOUR_RIGHTS_DESTRUCTION]:
    '•	طلب إتلاف البيانات التي لم تعد مطلوبة أو تمت معالجتها بشكل غير قانوني؛',
  [StringKey.PRIVACY_YOUR_RIGHTS_WITHDRAW_CONSENT]:
    '•	سحب الموافقة في الحالات التي تُعتبر فيها الأساس النظامي للمعالجة.',
  [StringKey.PRIVACY_YOUR_RIGHTS_P2]:
    'ستقوم معازيب بالرد على طلبات الحقوق خلال فترة زمنية معقولة لا تتجاوز 30 يومًا، وفقًا لما يسمح به نظام حماية البيانات الشخصية.',
  [StringKey.PRIVACY_BREACH_NOTIFICATION_TITLE]: 'الإخطار بحدوث خرق للبيانات',
  [StringKey.PRIVACY_BREACH_NOTIFICATION_P1]:
    'في حال وقوع خرق للبيانات الشخصية، ستقوم معازيب بما يلي:',
  [StringKey.PRIVACY_BREACH_NOTIFICATION_AUTHORITY]:
    '•	إخطار الجهة المختصة خلال المدة النظامية المحددة دون تأخير غير مبرر؛',
  [StringKey.PRIVACY_BREACH_NOTIFICATION_INDIVIDUALS]:
    '•	إخطار الأفراد المتأثرين إذا كان الخرق من المحتمل أن يؤدي إلى مخاطر كبيرة على حقوقهم أو حرياتهم؛',
  [StringKey.PRIVACY_BREACH_NOTIFICATION_DETAILS]:
    '•	توضيح طبيعة الخرق وفئات البيانات المتأثرة والتدابير المتخذة لمعالجته.',
  [StringKey.PRIVACY_BREACH_NOTIFICATION_P2]:
    'تتم جميع الإخطارات وفقًا للإجراءات والمواعيد المحددة في اللوائح التنفيذية لنظام حماية البيانات الشخصية.',
  [StringKey.PRIVACY_ELECTRONIC_SIGNATURES_TITLE]: 'السجلات والتوقيعات الإلكترونية',
  [StringKey.PRIVACY_ELECTRONIC_SIGNATURES_P1]:
    'تعتمد معازيب على السجلات والتوقيعات الإلكترونية وفقًا لنظام التعاملات الإلكترونية وإطاره التنظيمي، بما في ذلك استخدام الشهادات الرقمية الصادرة عن مزوّدي خدمات التصديق المرخصين عند الحاجة.',
  [StringKey.PRIVACY_LANGUAGE_TITLE]: 'اللغة وبيانات الشركة الرسمية',
  [StringKey.PRIVACY_LANGUAGE_P1]:
    'لغة السياسة: تم إعداد هذه السياسة باللغتين العربية والإنجليزية، وفي حال وجود أي تعارض بين النصين، تُعتبر النسخة العربية هي النسخة الرسمية والملزمة قانونًا.',
  [StringKey.PAGE_NOT_FOUND]: 'لم يتم العثور على الصفحة',
  [StringKey.PAGE_NOT_FOUND_DESC]: 'لم نتمكن من العثور على الصفحة التي تبحث عنها.',
  [StringKey.BACK_TO_HOME]: 'العودة إلى المنزل',

  [StringKey.INVITATION_ACCEPT_TITLE]: 'أنت جاهز تمامًا للحدث!',
  [StringKey.INVITATION_ACCEPT_DESC]:
    'تم إضافة تذكرتك بنجاح إلى ملفك الشخصي. يمكنك عرضها في أي وقت في تطبيق معازيب',
  [StringKey.INVITATION_REJECT_TITLE]: 'ربما في المرة القادمة',
  [StringKey.INVITATION_REJECT_DESC]:
    'نأسف لأنك لا تستطيع الحضور هذه المرة، لكننا نأمل في رؤيتك في أحداث معازيب المستقبلية.',
  [StringKey.EXPLORE_EVENTS]: 'استكشف الأحداث مع معازيب',
  [StringKey.TICKET_DETAILS]: 'تفاصيل التذكرة',
  [StringKey.FROM]: 'من',
  [StringKey.FREE]: 'حر',
  [StringKey.EVENT_NAME]: 'اسم الحدث',
  [StringKey.DATE_TIME]: 'التاريخ والوقت',
  [StringKey.LOCATION]: 'الموقع',
  [StringKey.TICKET_TYPE_SEATING_LABEL]: 'المقاعد',
  [StringKey.TICKET_TYPE_ENTRY_LABEL]: 'الدخول',
  [StringKey.SECTION]: 'القسم',
  [StringKey.ROW]: 'الصف',
  [StringKey.PLACE]: 'المكان',

  [StringKey.INVITATION_ERROR_TITLE]: 'عفواً! لم نتمكن من العثور على هذه الدعوة',
  [StringKey.INVITATION_ERROR_DESC]: 'يبدو أن هذه الدعوة غير موجودة أو لم تعد صالحة.',
};
